module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "ui arrow icon",
    class: {
      up: parseFloat(_vm.value) > 0,
        down: parseFloat(_vm.value) < 0
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-af2932e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArrowIcon.vue
// module id = 397
// module chunks = 1